import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import ActionLink from '../../components/ActionLink';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import CriteriaNumberRangeComponent from '../../components/criteria/CriteriaNumberRangeComponent';
import ActionService from '../../services/ActionService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import CriteriaCheckboxComponent from '../../components/criteria/CriteriaCheckboxComponent';
import Constants from '../../utils/constants';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import { Button, Menu } from 'primereact';

class ActionListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new ActionService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            renderDialog: false,
            eventDetails: undefined,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            showConfirmRemoveDialog: false,
        };
        this.service = new ActionService();
    }
    updateSearchCriteria(criteria) {
        return {
            locale: criteria.locale,
            title: criteria.title,
            hideExpired: criteria.hideExpired,
            coinsFrom: criteria.coinsFrom,
            coinsTo: criteria.coinsTo,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            locale: this.authService.getI18n(),
            hideExpired: false,
            title: '',
            coinsFrom: undefined,
            coinsTo: undefined,
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: false,
        };
    }

    initializeFromBackend() {}

    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'action.listTitle';
    }
    getCriteriaName() {
        return 'action-list-sc';
    }

    getContainerListName() {
        return 'action-list-container';
    }
    renderCriteria() {
        return (
            <div>
                <div className='row'>
                    <CriteriaTextComponent
                        id='text-sc'
                        name='title'
                        label={t('action.title')}
                        colClass='col-lg-4 col-sm-6'
                        value={this.state.criteria.title}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                    <CriteriaNumberRangeComponent
                        id='text-sc'
                        label={t('action.coins_range')}
                        colClass='col-lg-4 col-sm-6'
                        idFrom='coinsFrom'
                        idTo='coinsTo'
                        nameFrom='coinsFrom'
                        nameTo='coinsTo'
                        from={this.state.criteria.coinsFrom}
                        to={this.state.criteria.coinsTo}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                    <CriteriaCheckboxComponent
                        id='hideExpired'
                        name='hideExpired'
                        label={t('quiz.hideExpired')}
                        value={this.state.criteria.hideExpired}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                </div>
            </div>
        );
    }
    prepareHeaderItems() {
        const {t, newUrl} = this.props;
        const href = `${newUrl}/` + sessionStorage.getItem('i18nextLng');
        return this.isUserInAnyRole('ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR')
            ? [
                  {
                      label: t('global.addButton'),
                      onClick: () => {
                          //   window.location.href = AppPrefixUtils.locationHrefUrl(href);
                          this.props.history.push(AppPrefixUtils.locationHrefUrl(href));
                      },
                      type: 'BUTTON',
                      className: 'float-left',
                      variant: 'white',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                  },
              ]
            : [];
    }

    prepareColumns() {
        return [
            {field: 'id', header: 'ID', sortable: true, width: '90px'},
            {
                field: 'status.label',
                header: t('welcome-survey.list.status'),
            },
            {field: 'title', header: t('action.title'), sortable: false},
            {field: 'coinsToEarn', header: t('action.coinsToEarn'), sortable: true},
            {
                field: 'activeFrom',
                header: t('action.activeFrom'),
                sortable: true,
                body: this.dateTemplate.bind(this, 'activeFrom', Constants.DATE_TIME_FORMAT),
            },
            {
                field: 'activeTo',
                header: t('action.activeTo'),
                sortable: true,
                body: this.dateTemplate.bind(this, 'activeTo', Constants.DATE_TIME_FORMAT),
            },
            {field: 'action', header: t('global.action'), body: this.actionTemplate},
        ];
    }
    handleGoBack(e) {
        e.preventDefault();
        this.blockUi();
        const {backUrl} = this.props;
        // window.location.href = AppPrefixUtils.locationHrefUrl(backUrl);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderDialog() {
        return null;
    }

    actionTemplate(rowData) {
        const menuRef = React.createRef();
        const { detailUrl, userActionListUrl } = this.props;
        const detailHref = `${detailUrl}/${rowData?.id}/` + sessionStorage.getItem('i18nextLng');
        const userActionListHref = `${userActionListUrl}/${rowData?.id}/` + sessionStorage.getItem('i18nextLng');
    
        const menuItems = [
            {
                label: t('global.details'),
                icon: 'pi pi-eye',
                command: () => this.handleGoToDetail(detailHref),
            },
            rowData.status.status !== 'DRAFT' && {
                label: t('action.userActionList'),
                icon: 'pi pi-list',
                command: () => this.handleGoToDetail(userActionListHref),
            }
        ].filter(Boolean); // Usuwa `false` wartości, jeśli warunek nie jest spełniony
    
        return (
            <div>
                <Menu model={menuItems} popup ref={menuRef} />
                <Button
                    icon="pi pi-ellipsis-v"
                    className="menu-items"
                    onClick={(event) => menuRef.current.toggle(event)}
                />
            </div>
        );
    }

    breadCrumbItems() {
        return [{name: t('action.listTitle'), url: '/action-list'}];
    }
    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
}

ActionListContainer.defaultProps = {
    detailUrl: '/action/details',
    newUrl: '/action/create',
    editUrl: '/action/edit',
    userActionListUrl: '/user-action-list',
    renderChangeLanguegeFilter: true,
    lazy: true,
};

ActionListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(ActionListContainer));
